import React from 'react';
import { XIcon, MailIcon, PhoneIcon, ClockIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ContactModal({
  isOpen,
  onClose
}: ContactModalProps) {
  return <AnimatePresence data-id="element-1">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[60]" data-id="element-2" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="fixed left-1/2 top-[40%] -translate-x-1/2 -translate-y-1/2 w-full max-w-md z-[70] p-4" data-id="element-3">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-4">
              <div className="p-6" data-id="element-5">
                <div className="flex justify-between items-center mb-6" data-id="element-6">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-7">
                    Contact Support
                  </h3>
                  <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-500" data-id="element-8">
                    <XIcon className="w-5 h-5" data-id="element-9" />
                  </button>
                </div>

                <p className="text-gray-600 mb-4 leading-relaxed text-sm" data-id="element-10">
                  For more information and personalized assistance, contact us
                  exclusively through our WhatsApp Business or via email.
                </p>

                <div className="space-y-3" data-id="element-11">
                  <div className="flex items-center p-3 bg-gray-50 rounded-xl" data-id="element-12">
                    <div className="bg-teal-100 p-2 rounded-lg mr-3 text-teal-600 flex-shrink-0" data-id="element-13">
                      <PhoneIcon className="w-4 h-4" data-id="element-14" />
                    </div>
                    <div data-id="element-15">
                      <p className="text-xs font-medium text-gray-500 mb-0.5" data-id="element-16">
                        WhatsApp Business
                      </p>
                      <a href="https://wa.me/15512540741" target="_blank" rel="noopener noreferrer" className="text-base font-semibold text-gray-900 hover:text-teal-600 transition-colors" data-id="element-17">
                        +1 (551) 254-0741
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center p-3 bg-gray-50 rounded-xl" data-id="element-18">
                    <div className="bg-teal-100 p-2 rounded-lg mr-3 text-teal-600 flex-shrink-0" data-id="element-19">
                      <MailIcon className="w-4 h-4" data-id="element-20" />
                    </div>
                    <div data-id="element-21">
                      <p className="text-xs font-medium text-gray-500 mb-0.5" data-id="element-22">
                        Email
                      </p>
                      <a href="mailto:info@dreambuk.com" className="text-base font-semibold text-gray-900 hover:text-teal-600 transition-colors" data-id="element-23">
                        info@dreambuk.com
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center p-3 bg-teal-50 rounded-xl" data-id="element-24">
                    <div className="bg-teal-100 p-2 rounded-lg mr-3 text-teal-600 flex-shrink-0" data-id="element-25">
                      <ClockIcon className="w-4 h-4" data-id="element-26" />
                    </div>
                    <div data-id="element-27">
                      <p className="text-xs font-medium text-gray-500 mb-0.5" data-id="element-28">
                        Response Time
                      </p>
                      <p className="text-sm font-medium text-gray-800" data-id="element-29">
                        We typically respond within 24 hours on business days.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 px-6 py-4 text-center" data-id="element-30">
                <button onClick={onClose} className="text-gray-500 hover:text-gray-900 text-sm font-medium transition-colors" data-id="element-31">
                  Close Window
                </button>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}